import {UserRights} from '../../interfaces/core/user-rights';

export class UserRightsFactory {

  /**
   *
   * @param userRight
   */
  public static fromObject(userRight: any): UserRights {
    return {
      id: userRight.id,
      userId: userRight.user_id,
      customerDocuments: userRight.customer_documents,
      planningRoster: userRight.planning_roster,
      careDocumentation: userRight.care_documentation,
      identityCards: userRight.identity_cards,
      productManagement: userRight.product_management,
      processReports: userRight.process_reports ?? 3,
      operatingPlan: userRight.operating_plan,
      appointments: userRight.appointments,
      timeTracking: userRight.time_tracking,
      settings: userRight.settings
    };
  }
}
